import React from 'react';
import { Page, LandingContainer } from '@containers/layout';
import { Heading } from '@components/common';
import { PropertyForm } from '@containers/properties';

function PropertyPage() {
  return (
    <Page>
      <LandingContainer
        display="flex"
        flexDirection="column"
        justifyContent="center"
      >
        <Heading mb={1}>Your apartment</Heading>
        <PropertyForm />
      </LandingContainer>
    </Page>
  );
}

export default PropertyPage;
